import { generateLongitudeModal } from '../../LongitudeModal';
import { generateLatitudeModal } from '../../LatitudeModal';

const comments = 'The latitude and longitude of the location (city, state or island) where the tsunami effects occurred.';

export const MarLongitudeModal = generateLongitudeModal({ comments });

export const MarLatitudeModal = generateLatitudeModal({ comments });
